<template>
  <div class="pagos-resumenes">
    <b-row>
      <b-col>
        <b-card header="Datos del Resumen">
          <b-form>
            <b-form-group
              label="Banco"
              label-for="banco"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="banco" 
                :value="banco" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Tarjeta"
              label-for="tarjetaMarca"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="tarjetaMarca" 
                :value="tarjetaMarca"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Nro.Cuenta"
              label-for="numeroCuenta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroCuenta" 
                :value="numeroCuenta" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha de Cierre"
              label-for="fechaCierre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaCierre" 
                :value="fechaCierre | fecha" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha de Vencimiento"
              label-for="fechaVencimiento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaVencimiento" 
                :value="fechaVencimiento | fecha" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Total"
              label-for="totalCierre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="totalCierre" 
                :value="totalCierre | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Pagos"
              label-for="totalPagos"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="totalPagos" 
                :value="totalPagos | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>

      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Pagos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="pagos" 
              :fields="pagosFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(cotizacion)="data">
              {{ data.item.cotizacion | moneda }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="borrarItem(data.item)">
                  <i class="fa fa-remove"></i>Anular Pago</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Pago</b-dropdown-item>
          <!-- <b-dropdown-item @click.stop="exportarListado">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Órdenes</b-dropdown-item> -->
          <b-dropdown-item @click.stop="goResumenes">
            <i class="fa fa-undo"></i>Volver a Resúmenes</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'tarjetasResumenesPagos/getField',
  mutationType: 'tarjetasResumenesPagos/updateField',
});

export default {
  name: 'TarjetasResumenesPagosList',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      pagosFields: [
        // { 
        //   key: 'numero',
        //   label: 'Nro.Orden',
        //   class: 'text-right'
        // },
        { key: 'fechaRegistro' },
        {
          key: 'total',
          class: 'text-right'
        },
        {
          key: 'cotizacion',
          class: 'text-right'
        },
        { key: 'observaciones' },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'tarjetaResumenId',
      'banco',
      'tarjetaMarca',
      'numeroCuenta',
      'fechaCierre',
      'fechaVencimiento',
      'totalCierre',
      'totalPagos',

      'pagos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
    ]),
  },
  created() {
    let tarjetaResumenId = 0;
    if (this.$route.params){
      if (this.$route.params.tarjetaResumenId){
        tarjetaResumenId = this.$route.params.tarjetaResumenId;
      }
    }

    this.$store.dispatch('tarjetasResumenesPagos/inicializar', tarjetaResumenId)
      .then(() => this.getItems())
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.proveedor = filtro.proveedor;
      this.filtroFechaDocumentos = filtro.filtroFechaDocumentos;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('tarjetasResumenesPagos/getTarjetaResumenPagos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$router.push({ name: 'TarjetaResumenPago', 
                          params: { tarjetaResumenId: this.tarjetaResumenId }});
    },
    consultar (item) {
      this.$router.push({ name: 'TarjetaResumenPagoData', 
                          params: { tarjetaResumenId: this.tarjetaResumenId,
                                    id: item.id
                                  }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea anular el pago seleccionada?', this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar (tarjetaResumenPagoId) {
      this.showSpinner();
      this.$store.dispatch('tarjetasResumenesPagos/delete', tarjetaResumenPagoId)
        .then(() => this.showModalMsj('El pago se anuló con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    goResumenes() {
      this.$router.push({ name: 'TarjetasResumenes' }); 
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .pagos-resumenes .registro table td[aria-colindex="1"] {
    width: 15%;
  }
  .pagos-resumenes .registro table td[aria-colindex="2"] {
    width: 15%;
  }
  .pagos-resumenes .registro table td[aria-colindex="3"] {
    width: 15%;
  }
  .pagos-resumenes .registro table td[aria-colindex="4"] {
    width: Calc(70% - 30px);
  }
  .pagos-resumenes .registro table td[aria-colindex="5"] {
    width: 30px;
  }
</style>
